import { baseApi } from "@/store/baseApi";

export const shoppingListApi = baseApi.enhanceEndpoints({}).injectEndpoints({
  endpoints: (builder) => ({
    addToShoppingList: builder.mutation<void, number[]>({
      query: (mpIds) => ({
        url: "neo/shopping-list",
        method: "POST",
        body: mpIds,
      }),
    }),
    removeFromShoppingList: builder.mutation<void, number[]>({
      query: (mpIds) => ({
        url: "neo/shopping-list",
        method: "DELETE",
        body: mpIds,
      }),
    }),
  }),
});

export const { useAddToShoppingListMutation, useRemoveFromShoppingListMutation } = shoppingListApi;

export const { addToShoppingList, removeFromShoppingList } = shoppingListApi.endpoints;
